import { useEffect, useState } from "react";
import ContentBody from "./ContentBody";

const API = process.env.REACT_APP_BACKEND_URL;

export default function TermsModal({ onClose, onAccept, alreadyAccepted }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/content/deelnemersvoorwaarden`)
      .then(r => r.ok ? r.json() : null)
      .then(data => setContent(data))
      .catch(() => {});

    // Sluit met Escape
    const onKey = e => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="terms-overlay" onClick={onClose}>
      <div className="terms-modal" onClick={e => e.stopPropagation()}>
        <div className="terms-modal-header">
          <h2>{content?.title || "Deelnemersvoorwaarden"}</h2>
          <button type="button" className="terms-close" onClick={onClose} aria-label="Sluiten">×</button>
        </div>
        <div className="terms-modal-body">
          {content ? (
            <ContentBody data={content} />
          ) : (
            <p>Laden…</p>
          )}
        </div>
        {!alreadyAccepted && (
          <div className="terms-modal-footer">
            <button type="button" className="btn-secondary" onClick={onClose}>Sluiten</button>
            <button type="button" onClick={onAccept}>Akkoord</button>
          </div>
        )}
      </div>
    </div>
  );
}
